import logger from '../../../core/utils/src/logger';
export default function deprecateExport(exportObject) {
    var descriptors = {};
    Object.keys(exportObject).forEach(function (key) {
        descriptors[key] = {
            enumerable: true,
            get: function () {
                logger.warnOnce('Default export has been deprecated. Use `* as` syntax instead');
                return exportObject[key];
            }
        };
    });
    return Object.create({}, descriptors);
}
//# sourceMappingURL=deprecate-export.js.map